import React, { useEffect, useState } from "react";
import { Eye, PlusCircle } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import Loader from '../../../components/menu/Loader';
import { fetchClaimProcess, getPatientMemberDetails } from "../../../stores/slices/claimIntake/claimProcessSlice";
import { setConditionalRoute } from "../../../stores/slices/generalConfiguration/routeRestrictionSlice";
import Table from "../../../components/reactTable/Table";
import { resetClaimIntakeData } from "../../../stores/slices/claimIntake/claimIntakeSlice";
import { Tooltip } from "antd";
import { fetchClaimDetails, resetClaimDetails } from "../../../stores/slices/claimDetailSlice";
import { fetchClaimList, resetClaimList } from "../../../stores/slices/claimIntake/claimListSlice";

function Claims() {
  const navigate = useNavigate()
  const applicationData = useSelector((state) => state.appViewDetailsSlice);
  const dispatch = useDispatch()
  const data = useSelector((state) => state.claimListSlice.appClaims)
  const loginStatus = useSelector((state) => state.loginSlice);
  const loader = useSelector((state) => state.claimListSlice.loader)
  const [trigerLoader, setTriggerLoader] = useState(false);
  
  const claimInfo = () => {
    setTriggerLoader(true);
    dispatch(resetClaimList());
    dispatch(fetchClaimList({ appID: undefined, ein: loginStatus.value.EIN, prgData: "CPR" }));
    dispatch(fetchClaimList({ appID: undefined, ein: loginStatus.value.EIN, prgData: "FAF" }));
    setTimeout(()=> {
      setTriggerLoader(false)
    }, 2000);
  }

  useEffect(()=>{
    return claimInfo;
  },[])

  const submitClaim = () => {
    dispatch(fetchClaimProcess({ appID: applicationData.viewAppInfo.applicationId, prgData: applicationData.program }))
    dispatch(getPatientMemberDetails({ memberId: applicationData.patientInfo.patientId, prgData: applicationData.program }))
    dispatch(resetClaimIntakeData())
    navigate('/claims/claimintake')

    dispatch(setConditionalRoute({
      isFlag: true,
      currentFlow: 'Claim',
    }))
  }

  const viewClaim = (props) => {
    let data = props.row.original ? props.row.original : props;
    dispatch(resetClaimDetails());
    dispatch(fetchClaimDetails({ PCaseID: data.claimID, prgData: data.program }))
    return navigate('/claims/Details')
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'POE ID',
        accessor: '',
      },
      {
        Header: 'POE ID',
        accessor: 'claimID',
      },
      {
        Header: 'Check No',
        accessor: 'checkNo',
      },
      // {
      //   Header: 'Patient Name',
      //   accessor: 'patientName',
      // },
      {
        Header: 'Submission Date',
        accessor: 'submissionDate',
      },
      {
        Header: 'Amount Submitted',
        accessor: 'submittedAmount',
      },
      // {
      //   Header: 'Paid Amount',
      //   accessor: 'paidAmount',
      // },
      {
        Header: 'Status',
        accessor: 'status',
      },
      {
        Header: 'Action',
        accessor: 'actions',
        disableSortBy: true,
        Cell: props => {
          return <div className="d-flex justify-content-center align-items-center">
            <Tooltip placement='top' title={'View Claim'}><a className="d-flex align-items-center cursor-pointer" onClick={() => viewClaim(props)}> <Eye /></a></Tooltip>
          </div>
        },
      },
    ],
    []
  );


  return (
    <div>
      {(trigerLoader || loader) ? <Loader /> : null}
      {" "}
      <div class="intro-y box mt-lg-5">
        <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
          <h2 class="fw-medium fs-base me-auto">Claims Information</h2>
          {applicationData.allowToSubmitClaim && <button className=" btn btn-yellow" onClick={() => { submitClaim() }}><div className="p-1 h-15"><PlusCircle /></div> Submit Claim</button>}
        </div>
        {data.length > 0 ? <Table columns={columns} data={[...new Set(data)]} showPageDataCount={5} searchFilter={true} /> : "No claim found!"}
      </div>
    </div>
  );
}

export default Claims;
